import { render, staticRenderFns } from "./SingleTransaction.vue?vue&type=template&id=6a9ffe34&scoped=true&"
import script from "./SingleTransaction.vue?vue&type=script&lang=js&"
export * from "./SingleTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SingleTransaction.vue?vue&type=style&index=0&id=6a9ffe34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ffe34",
  null
  
)

export default component.exports